var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linear-chart"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.$props.label))]),_c('div',{staticClass:"value"},[_vm._t("value",function(){return [_vm._v(_vm._s(_vm.$props.valueLabel))]})],2),_c('div',{staticClass:"bar"},[_c('div',{staticClass:"progress",class:_vm.barClasses,style:(_vm.calculatedProgress)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }